import { Component, Input, OnChanges } from '@angular/core';
import { ErreurInput } from '../../models/erreurs/erreur-input';
import { ErreurMappingService } from '../../services/errors/erreur-mapping.service';

@Component({
  selector: 'app-erreur-input-telephone',
  templateUrl: './erreur-input-telephone.component.html',
  standalone: false,
})
export class ErreurInputTelephoneComponent implements OnChanges {
  @Input() erreurInput: ErreurInput;

  currentError: string;

  constructor(private readonly erreurMappingTelephoneForm: ErreurMappingService) {}

  ngOnChanges() {
    if (!this.erreurInput.hasError) return;
    this.currentError = this.erreurMappingTelephoneForm.getErrorTextFromMappingErreurInput(this.erreurInput);
  }
}
